export default function zigZagScript() {

  const zigZagAdditional = document.querySelectorAll('.c-zig-zag__content-additional');
  const SCROLL_DELAY = 140; // ms – wait for height animation start

  if (!zigZagAdditional.length) return;

  const getHeaderOffset = () => {
    const header = document.querySelector('.c-header');
    return header ? header.offsetHeight + 15 : 0;
  };

  const scrollToContent = (content) => {
    setTimeout(() => {
      const rect = content.getBoundingClientRect();

      window.scrollTo({
        top: window.pageYOffset + rect.top - getHeaderOffset(),
        behavior: 'smooth',
      });
    }, SCROLL_DELAY);
  };

  zigZagAdditional.forEach((item) => {

    const button = item.querySelector('.c-zig-zag__content-additional-toggle');
    const content = item.querySelector('.c-zig-zag__content-additional-text');

    if (!button || !content) return;

    button.addEventListener('click', () => {
      const isOpen = content.classList.contains(
        'c-zig-zag__content-additional-text--active'
      );

      if (isOpen) {
        // CLOSE (no scroll)
        content.classList.remove('c-zig-zag__content-additional-text--active');
        button.innerText = button.dataset.textDefault;

        content.style.height = `${content.scrollHeight}px`;
        content.style.transition = 'height 0.25s ease-in-out';
        content.offsetHeight;
        content.style.height = '0px';
        return;
      }

      // OPEN (scroll after reveal starts)
      content.classList.add('c-zig-zag__content-additional-text--active');
      button.innerText = button.dataset.textExpanded;

      content.style.height = '0px';
      content.style.transition = 'height 0.25s ease-in-out';
      content.offsetHeight;
      content.style.height = `${content.scrollHeight}px`;

      scrollToContent(content);
    });
  });
}
